import { CLEAR_INFO } from './constants';

export function clearAgentInfoVerificationAction() {
  return { type: CLEAR_INFO }
}

export function reducer(state, { type }) {
  switch (type) {
    case CLEAR_INFO:
      return {}
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/agent-info-verification/redux/clearAgentInfoVerification.js